import { SingleValueRxEmitter } from '@ocodelib/ex-util';

/**
 * 로그인 다이얼로그 표시 이벤트
 */
export const LoginDialogOpenEvent = new SingleValueRxEmitter(0);
